// Pure price math for the ale-v2 landing. Every number it produces is DERIVED from
// the prices the Puentify widget renders, so the page can never show something
// that isn't charged (instalaciones/CLAUDE.md: never paint a price).
// ES5 on purpose: it is pasted inside a Shopify custom_liquid <script>. Keep it free
// of Liquid delimiters (double braces, brace-percent).
var AlePriceMath = (function () {
  // "$ 51.120" / "$ 83.120,01" / "Comprar | $ 63.900" -> pesos (number) or null.
  function parseArs(text) {
    var m = String(text === null || text === undefined ? "" : text).match(/\$\s*([\d.]+)(?:,(\d{1,2}))?/);
    if (!m) return null;
    var n = parseInt(m[1].replace(/\./g, ""), 10);
    if (isNaN(n)) return null;
    return m[2] ? n + parseInt(m[2], 10) / Math.pow(10, m[2].length) : n;
  }

  // Every amount in a text, in order ("$ 35.120$ 43.900" -> [35120, 43900]).
  function parseArsAll(text) {
    var out = [];
    var re = /\$\s*[\d.]+(?:,\d{1,2})?/g;
    var m;
    while ((m = re.exec(String(text === null || text === undefined ? "" : text)))) out.push(parseArs(m[0]));
    return out;
  }

  function toCents(pesos) {
    return Math.round(pesos * 100);
  }

  function fromCents(cents) {
    return cents / 100;
  }

  // The mockup writes "$51.120" (no space). Cents only when non-zero ("$83.120,01").
  function money(pesos) {
    var cents = toCents(pesos);
    var whole = Math.floor(cents / 100);
    var rest = cents % 100;
    var s = "$" + String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return rest ? s + "," + (rest < 10 ? "0" : "") + rest : s;
  }

  function sub(a, b) {
    return fromCents(toCents(a) - toCents(b));
  }

  function add(a, b) {
    if (a === null || b === null) return null;
    return fromCents(toCents(a) + toCents(b));
  }

  function times(a, n) {
    return fromCents(toCents(a) * n);
  }

  function perUnit(total, qty) {
    return fromCents(Math.round(toCents(total) / qty));
  }

  function pctOff(price, strike) {
    if (!strike || price >= strike) return null;
    return Math.round((1 - price / strike) * 100);
  }

  // Saving over the first `charges` charges: the first one saves `firstSave`,
  // every later one saves `nextSave`.
  function savingsOver(charges, firstSave, nextSave) {
    if (firstSave === null || nextSave === null) return null;
    return fromCents(toCents(firstSave) + toCents(nextSave) * (charges - 1));
  }

  // "3 cuotas sin interés de $X": the mockup rounds total / n to the peso.
  function installment(total, n) {
    if (total === null || total === undefined) return null;
    return Math.round(total / n);
  }

  // What the 2nd delivery charges, from the widget's delivery-progression rows
  // ({label: "2ª entrega", price: "$ 38.851,20"}). A schedule with no row for
  // delivery 2 charges the regular price; an unreadable price is null (fail open).
  function nextCharge(rows, first) {
    for (var i = 0; i < rows.length; i++) {
      var n = String(rows[i].label).match(/(\d+)/);
      if (n && parseInt(n[1], 10) === 2) return parseArs(rows[i].price);
    }
    return first;
  }

  // What the 2nd delivery charges when the plan takes a fixed amount off the tier
  // total (no progression rows to read). Never below 0; an unknown price is null.
  function nextAfterFixedOff(price, off) {
    if (price === null || !isFinite(price)) return null;
    return Math.max(0, sub(price, off));
  }

  // A tier's delivery-progression row elements. Until 28/09 the widget drew them
  // inside each tier card; since widget #507 they live in one shared block that
  // shows only the SELECTED tier's rows. Another tier's rows are not on the page:
  // null (unknown), so the caller never mistakes them for "no schedule".
  var STEP = '[data-mpw-row="delivery-step"]';
  function stepRows(tier, root) {
    var own = tier.querySelectorAll(STEP);
    if (own.length) return own;
    if (tier.getAttribute("aria-checked") !== "true") return null;
    return root.querySelectorAll('[data-mpw-row="delivery-progression"] ' + STEP);
  }

  // Label and price text of one delivery-step element. Since widget #512 (29/09)
  // the step is div.mpw-dp-step > [div.mpw-dp-conn, div.mpw-dp-label,
  // div.mpw-dp-price, div.mpw-dp-pct?]; before, div > [span label, span > [span
  // price, span pct]]. Read by class first, else by the old positions. An unknown
  // shape gives empty strings, which nextCharge treats as unreadable (fail open).
  function stepData(stepEl) {
    var label = stepEl.querySelector(".mpw-dp-label");
    var price = stepEl.querySelector(".mpw-dp-price");
    if (label || price) {
      return { label: label ? label.textContent : "", price: price ? price.textContent : "" };
    }
    var right = stepEl.children[1];
    return {
      label: stepEl.children[0] ? stepEl.children[0].textContent : "",
      price: right && right.children[0] ? right.children[0].textContent : "",
    };
  }

  function units(n, singular, plural) {
    return n + " " + (n === 1 ? singular : plural);
  }

  // Text of the pill that flips the mode: while subscribed it offers the one-time
  // price of 1 unit, while one-time it offers the first subscription charge.
  function switchLabel(sub, copy, once1, firstSub) {
    // The template copy ships separately from this asset and may lack the keys.
    var c = copy || {};
    var tpl = sub
      ? c.badgeToOnce || "¿Preferís compra única? {x}"
      : c.badgeToSub || "Suscribirme por {x}";
    var x = money(sub ? once1 : firstSub);
    return tpl.replace("{x}", function () {
      return x;
    });
  }

  return {
    parseArs: parseArs,
    parseArsAll: parseArsAll,
    money: money,
    sub: sub,
    add: add,
    times: times,
    perUnit: perUnit,
    pctOff: pctOff,
    savingsOver: savingsOver,
    installment: installment,
    nextCharge: nextCharge,
    nextAfterFixedOff: nextAfterFixedOff,
    stepRows: stepRows,
    stepData: stepData,
    units: units,
    switchLabel: switchLabel,
  };
})();


// ale-v2 page script: renders Ale's subscription mockup and drives the (hidden)
// Puentify widget, which stays the purchase engine. ES5 on purpose: pasted inside
// a Shopify custom_liquid <script>. Keep it free of Liquid delimiters.
//
// - Every number shown is read from what the widget renders (tier prices, strikes,
//   gift price, CTA total) and derived with AlePriceMath. Nothing is typed.
// - Our controls forward real clicks to the widget's own controls (subscribe
//   switch, tier radios, gift checkbox) and our CTA clicks the widget's CTA, so
//   checkout and cart behave exactly as today.
// - FAIL OPEN: html.alev2-on (which hides the widget and shows our UI) is only set
//   once every required number has been read. Short of that, the widget stays.
(function () {
  "use strict";

  var S = window.ALE_STORE;
  var M = window.AlePriceMath;
  var C = S.copy;
  // Paid add-ons (PlanUpsell): opt-in rows in both states, charged in every cycle of
  // the subscription. Optional: a store without them renders exactly as before.
  var UPS = C.upsells || [];
  var TIMEOUT_MS = 12000;
  // Pesos off the tier total from the 2nd delivery (plan deliveryBenefits, 16/10). The widget
  // draws no progression rows for those plans, so M.nextCharge would fall back to the tier price.
  // ponytail: hardcoded 2nd-delivery price for the Lauti stores until the widget sends the ladder price (Flow PW #431); remove this map then.
  var FIXED_OFF = { blush: 10000, babymoon: 10000, blze: 10000, knockout: 10000 };
  // The "bloom" layout needs its own copy and the servings per unit. A store missing any
  // of them gets the default layout instead of cards that print "undefined".
  var B = C.bloom || {};
  var BLOOM_COPY = ["subTitle", "subPill", "subSub", "perServing", "qtyLess", "qtyMore", "ctaSub", "ctaOnce", "onceTitle", "onceSub", "ctaNoteSubFlat"];
  var BLOOM =
    S.layout === "bloom" &&
    S.servingsPerUnit > 0 &&
    BLOOM_COPY.every(function (k) {
      return typeof B[k] === "string";
    });
  if (S.layout === "bloom" && !BLOOM && window.console) console.warn("[alev2] bloom copy or servingsPerUnit missing — default layout");

  var state = { sub: true, qty: 1, gifts: {}, upsells: {}, detail: false, animate: true };
  // gifts: price per gift title, read from the widget's one-time "Sumá a tu pedido" rows.
  // upsells: per title {sub: {price, strike}, once: price}, read from the widget's rows.
  // subs/subQtys: every subscription tier by quantity (the bloom layout's stepper sells
  // "N per delivery"); the default layout only uses data.sub, the 1-unit tier.
  var data = { sub: null, subs: {}, subQtys: [], once: {}, gifts: {}, upsells: {}, onceQtys: [] };
  var phase = "harvest"; // "harvest" | "active" | "failed"
  var el = null; // our container
  var root = null; // the widget mount

  function warn(reason) {
    document.documentElement.classList.add("alev2-off"); // ends the CSS hold on the widget
    if (window.console) console.warn("[alev2] " + reason + " — leaving the widget visible");
  }

  function fill(tpl, vars) {
    return String(tpl).replace(/\{(\w+)\}/g, function (m, k) {
      return vars[k] !== undefined ? vars[k] : m;
    });
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  // ---- reading the widget ---------------------------------------------------

  function checkbox() {
    return root.querySelector('button[role="checkbox"]');
  }
  function isSubOn() {
    var cb = checkbox();
    return cb ? cb.getAttribute("aria-checked") === "true" : null;
  }
  function cta() {
    return root.querySelector("[data-mpw-cta]");
  }

  function readTiers() {
    var out = [];
    var tiers = root.querySelectorAll(".mpw-tier");
    for (var i = 0; i < tiers.length; i++) {
      var t = tiers[i];
      var titleEl = t.querySelector('[data-mpw-row="title"]');
      var priceEl = t.querySelector('[data-mpw-row="price"]');
      if (!titleEl || !priceEl) return null;
      var qm = (titleEl.textContent || "").match(/(\d+)/);
      var price = M.parseArs(priceEl.textContent);
      if (!qm || price === null) return null;
      var pillEl = titleEl.nextElementSibling;
      var strikeEl = t.querySelector('[data-mpw-row="strike"]');
      var ribbonEl = t.querySelector('[data-mpw-row="badge"]');
      // Per-delivery discount schedule. Widget DOM contract relied on: rows are
      // [data-mpw-row="delivery-step"] (in the card, or in the shared
      // [data-mpw-row="delivery-progression"] block for the selected tier), each
      // with a .mpw-dp-label ("2ª entrega" / "Nª en adelante") and a
      // .mpw-dp-price ("$ 39.873,60") since widget #512; M.stepData falls back to
      // the pre-#512 positions. null = this tier's rows are not on the page.
      var steps = [];
      var stepEls = M.stepRows(t, root);
      for (var s = 0; stepEls && s < stepEls.length; s++) steps.push(M.stepData(stepEls[s]));
      out.push({
        el: t,
        qty: parseInt(qm[1], 10),
        title: (titleEl.textContent || "").trim(),
        pill: pillEl ? (pillEl.textContent || "").trim() : "",
        price: price,
        strike: strikeEl ? M.parseArs(strikeEl.textContent) : null,
        next: FIXED_OFF[S.store] !== undefined ? M.nextAfterFixedOff(price, FIXED_OFF[S.store]) : stepEls === null ? null : M.nextCharge(steps, price),
        ribbon: ribbonEl ? (ribbonEl.textContent || "").trim() : "",
        checked: t.getAttribute("aria-checked") === "true",
      });
    }
    return out.length ? out : null;
  }

  // A gift (PlanGift) row: in one-time the widget renders it as a <label> with a
  // checkbox and the live Shopify price; ticking it adds the product to the cart.
  // In subscription it is included at $0. Matched by the gift's title, never by
  // position.
  function giftInput(title) {
    var inputs = root.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < inputs.length; i++) {
      var lab = inputs[i].closest("label");
      if (lab && lab.textContent.indexOf(title) !== -1) return inputs[i];
    }
    return null;
  }
  function giftPriceFromWidget(title) {
    var inp = giftInput(title);
    return inp ? M.parseArs(inp.closest("label").textContent) : null;
  }

  // Every amount in a paid add-on row: subscription "$ 35.120$ 43.900" (price, then
  // the list price struck), one-time "$ 43.900".
  function upsellAmounts(title) {
    var inp = giftInput(title);
    return inp ? M.parseArsAll(inp.closest("label").textContent) : [];
  }
  function upsellData(title) {
    if (!data.upsells[title]) data.upsells[title] = {};
    return data.upsells[title];
  }

  function ctaTotal() {
    var b = cta();
    return b ? M.parseArs(b.textContent) : null;
  }

  function harvestCurrent() {
    var sub = isSubOn();
    var tiers = readTiers();
    if (sub === null || !tiers) return;
    if (sub) {
      // Mid re-render the switch can already say subscription while the tiers are
      // still the one-time ones (one-time tier 1 has no strike): skip that read.
      // Bloom only: the default layout keeps its original read below, unchanged.
      if (BLOOM) {
        for (var w = 0; w < tiers.length; w++) if (tiers[w].qty === 1 && tiers[w].strike === null) return;
      }
      data.subQtys = [];
      for (var i = 0; i < tiers.length; i++) {
        var t = tiers[i];
        // store.subQtys: the quantities the subscription sells (default every tier). BLZE: [1],
        // its 2- and 3-unit tiers renew every 2 and 3 months, not "cada mes" (user 07/10).
        if (S.subQtys && S.subQtys.indexOf(t.qty) === -1) continue;
        // A tier's 2nd charge is only readable while it is selected: keep the last read.
        var prev = data.subs[t.qty];
        if (t.next === null && prev) t.next = prev.next;
        data.subs[t.qty] = t;
        data.subQtys.push(t.qty);
        if (t.qty === 1) data.sub = t;
      }
      for (var u = 0; u < UPS.length; u++) {
        var a = upsellAmounts(UPS[u].match);
        if (a.length) upsellData(UPS[u].match).sub = { price: a[0], strike: a.length > 1 ? a[1] : null };
      }
    } else {
      // Mid re-render the switch can already say one-time while the tiers are
      // still the subscription ones (they carry a strike; one-time tier 1 doesn't).
      for (var s = 0; s < tiers.length; s++) if (tiers[s].qty === 1 && tiers[s].strike !== null) return;
      data.onceQtys = [];
      for (var j = 0; j < tiers.length; j++) {
        data.once[tiers[j].qty] = tiers[j];
        data.onceQtys.push(tiers[j].qty);
      }
      for (var k = 0; k < C.gifts.length; k++) {
        var g = giftPriceFromWidget(C.gifts[k].match);
        if (g !== null) data.gifts[C.gifts[k].match] = g;
      }
      for (var v = 0; v < UPS.length; v++) {
        var b = upsellAmounts(UPS[v].match);
        if (b.length) upsellData(UPS[v].match).once = b[0];
      }
    }
  }

  function haveAll() {
    for (var k = 0; k < C.gifts.length; k++) if (data.gifts[C.gifts[k].match] === undefined) return false;
    for (var u = 0; u < UPS.length; u++) {
      var d = data.upsells[UPS[u].match];
      if (!d || !d.sub || d.once === undefined) return false;
    }
    if (BLOOM && subMissingNext()) return false;
    return !!(data.sub && data.sub.next !== null && data.once[1] && data.onceQtys.length && cta());
  }

  // The first subscription tier whose 2nd charge has not been read yet (bloom shows every
  // tier's), or null.
  function subMissingNext() {
    for (var i = 0; i < data.subQtys.length; i++) {
      var t = data.subs[data.subQtys[i]];
      if (t.next === null) return t;
    }
    return null;
  }

  // ---- driving the widget ---------------------------------------------------

  // One step towards our state; returns true when the widget already matches.
  function syncStep() {
    var cb = checkbox();
    if (!cb) return false;
    if ((cb.getAttribute("aria-checked") === "true") !== state.sub) {
      cb.click();
      return false;
    }
    // The default layout subscribes 1 unit; bloom's stepper picks the quantity in both modes.
    var want = state.sub && !BLOOM ? 1 : state.qty;
    var tiers = readTiers();
    if (!tiers) return false;
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].qty === want && !tiers[i].checked) {
        tiers[i].el.click();
        return false;
      }
    }
    if (!state.sub) {
      for (var k = 0; k < C.gifts.length; k++) {
        var gi = giftInput(C.gifts[k].match);
        if (gi && gi.checked !== !!state.gifts[C.gifts[k].match]) {
          gi.click();
          return false;
        }
      }
    }
    for (var u = 0; u < UPS.length; u++) {
      var ui = giftInput(UPS[u].match);
      if (ui && ui.checked !== !!state.upsells[UPS[u].match]) {
        ui.click();
        return false;
      }
    }
    return true;
  }

  var syncTimer = null;
  function sync(then) {
    var tries = 0;
    if (syncTimer) clearTimeout(syncTimer);
    (function step() {
      if (syncStep()) {
        if (then) then(true);
        return;
      }
      if (++tries > 20) {
        warn("could not sync the widget");
        if (then) then(false);
        return;
      }
      syncTimer = setTimeout(step, 80);
    })();
  }

  // ---- markup ----------------------------------------------------------------

  var ICON = {
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6 9 17l-5-5"/></svg>',
    tick: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M20 6 9 17l-5-5"/></svg>',
    truck:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>',
    chat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 9 9 0 0 1-2.8-.4L4 21l1.5-4.2A8.4 8.4 0 0 1 12 3a8.4 8.4 0 0 1 9 8.5z"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 3l7 3v6c0 4.2-2.9 7.8-7 9-4.1-1.2-7-4.8-7-9V6z"/></svg>',
  };

  function img(key) {
    return S.imageBase + S.images[key];
  }

  function numbers() {
    // Bloom prices the subscription tier of the stepper's quantity; the default layout
    // always subscribes the 1-unit tier.
    var st = BLOOM && data.subs[state.qty] ? data.subs[state.qty] : data.sub;
    var p = st.price;
    var was = st.strike;
    var once1 = data.once[1].price;
    var saveToday = M.sub(was, p);
    // From the 2nd charge on: the widget's delivery-discount schedule (row 2), or
    // the same price when the tier has no schedule.
    var next = st.next;
    var saveNext = M.sub(was, next);
    // Ticked paid add-ons, charged in every cycle: added to today's amount, its strike
    // and the recurring amount; the saving stays the product's (the mockup's rule).
    var extra = 0;
    for (var u = 0; u < UPS.length; u++) {
      if (state.sub && state.upsells[UPS[u].match]) extra = M.add(extra, data.upsells[UPS[u].match].sub.price);
    }
    return {
      qty: st.qty,
      p: p,
      was: was,
      once1: once1,
      next: next,
      extra: extra,
      today: M.add(p, extra),
      todayWas: M.add(was, extra),
      nextAll: M.add(next, extra),
      saveToday: saveToday,
      saveNext: saveNext,
      six: M.savingsOver(6, saveToday, saveNext),
      pct: M.pctOff(p, was),
      total: ctaTotal(),
      cuota: M.installment(ctaTotal(), 3),
    };
  }

  function kept(list) {
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var it = list[i];
      if (typeof it === "string") out.push({ text: it, label: it });
      else if (!it.needsFreeShipping || S.freeShipping) out.push(it);
    }
    return out;
  }

  // The bundle's head: the two badges above the subscription card. They replace
  // the widget's own badge row; the rest of the page (gallery, title, reviews)
  // stays the theme's.
  function badgesHtml(n) {
    // The first pill is a button that flips the mode (same action as the toggle).
    var btn =
      '<button type="button" class="alev2-pill is-switch" data-alev2="toggle" aria-pressed="' + state.sub + '">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M6 13l6 6 6-6"/></svg>' +
      "<span>" + esc(M.switchLabel(state.sub, C, n.once1, n.p)) + "</span></button>";
    var badges = state.sub
      ? btn + (S.freeShipping ? '<span class="alev2-pill is-ship">' + esc(C.badgeShipSub) + "</span>" : "")
      : btn + '<span class="alev2-pill is-muted-line">' + esc(fill(C.badgeShipOnce, { cuota: n.cuota === null ? "" : M.money(n.cuota) })) + "</span>";
    return '<div class="alev2-badges">' + badges + "</div>";
  }

  function subCardHtml(n) {
    var bens = kept(C.benefits);
    var bensHtml = "";
    for (var i = 0; i < bens.length; i++) bensHtml += "<li>" + ICON.tick + " " + esc(bens[i].text) + "</li>";
    var rows = kept(C.detailRows);
    var rowsHtml = "";
    for (var j = 0; j < rows.length; j++) {
      rowsHtml +=
        "<div><span>" + esc(rows[j].label) + "</span>" +
        (rows[j].strikeGift
          ? "<s>" + M.money(data.gifts[rows[j].strikeGift]) + "</s>"
          : "<b>" + esc(fill(rows[j].value, { subPrice: M.money(n.p) })) + "</b>") +
        "</div>";
    }
    var lede = C.subLede + (S.freeShipping ? " " + C.subLedeShip : "");
    return (
      '<div class="alev2-sub' + (state.animate ? " alev2-rise" : "") + '">' +
      '<span class="alev2-flag">' + esc(C.subFlag) + "</span>" +
      '<div class="alev2-subbox">' +
      '<button type="button" class="alev2-toggle" data-alev2="toggle" aria-pressed="true">' +
      '<span class="alev2-box is-on-dark">' + ICON.check + "</span>" +
      '<span class="alev2-tt"><b>' + esc(C.subTitle) + "</b><span>" + esc(lede) + "</span></span></button>" +
      '<div class="alev2-inner"><div class="alev2-inner-top">' +
      '<div class="alev2-inner-img"><img src="' + img("card") + '" alt="' + esc(C.cardTitle) + '"></div>' +
      '<div class="alev2-inner-body"><b>' + esc(C.cardTitle) + "</b>" +
      '<div class="alev2-chips">' +
      (S.freeShipping ? '<span class="alev2-chip is-strong">' + ICON.truck + esc(C.cardShipPill) + "</span>" : "") +
      '<span class="alev2-chip is-soft">' + esc(data.sub.pill) + "</span></div>" +
      '<div class="alev2-today"><small>' + esc(C.today) + "</small><strong>" + M.money(n.today) + "</strong><s>" + M.money(n.todayWas) + "</s></div>" +
      '<div class="alev2-save">' + esc(fill(C.saveToday, { x: M.money(n.saveToday) })) + "</div>" +
      "</div></div>" +
      '<div class="alev2-next"><div class="alev2-next-l"><b>' + esc(C.nextHead) + "</b><span>" +
      esc(fill(C.saveNext, { x: M.money(n.saveNext) })) + "</span></div>" +
      '<div class="alev2-next-r"><strong>' + M.money(n.nextAll) + "</strong><span>" + esc(C.perMonth) + "</span></div></div>" +
      '<div class="alev2-cmp">' +
      "<div><small>" + esc(C.cmpOnce) + '</small><b class="is-was">' + M.money(n.once1) + "</b></div>" +
      "<div><small>" + esc(C.cmpSub) + '</small><b class="is-now">' + M.money(n.p) + "</b></div>" +
      "<div><small>" + esc(C.cmpSix) + '</small><b class="is-good">' + esc(fill(C.cmpSixValue, { x: M.money(n.six) })) + "</b></div>" +
      "</div>" +
      upsellNoticeHtml() +
      "</div>" +
      '<ul class="alev2-bens">' + bensHtml + "</ul>" +
      '<button type="button" class="alev2-more" data-alev2="detail" aria-expanded="' + state.detail + '"><span>' +
      esc(state.detail ? C.detailHide : C.detailShow) + "</span><span>" + (state.detail ? "↑" : "↓") + "</span></button>" +
      (state.detail ? '<div class="alev2-detail alev2-rise">' + rowsHtml + "</div>" : "") +
      "</div></div>"
    );
  }

  // "Incluye Pack de 6 Blush Soda de $35.120 en cada cobro", under the card (mockup).
  function upsellNoticeHtml() {
    var out = "";
    for (var u = 0; u < UPS.length; u++) {
      if (!state.upsells[UPS[u].match]) continue;
      out +=
        '<div class="alev2-notice">' +
        esc(fill(C.upsellNotice, { title: UPS[u].title, x: M.money(data.upsells[UPS[u].match].sub.price) })) +
        "</div>";
    }
    return out;
  }

  function onceHtml(n) {
    var tail = S.freeShipping ? C.teaserTailShip : C.teaserTail;
    var html =
      '<button type="button" class="alev2-teaser' + (state.animate ? " alev2-rise" : "") + '" data-alev2="toggle" aria-pressed="false">' +
      '<span class="alev2-box is-off"></span>' +
      '<span class="alev2-tt"><b>' + esc(C.teaserTitle) + "</b><span>" +
      esc(fill(C.teaserText, { first: M.money(n.p) })) + "<strong>" + esc(fill(C.teaserStrong, { next: M.money(n.next) })) + "</strong>" + esc(tail) +
      "</span></span></button>" +
      '<p class="alev2-label">' + esc(C.onceHead) + "</p>";
    for (var i = 0; i < data.onceQtys.length; i++) {
      var q = data.onceQtys[i];
      var t = data.once[q];
      var strike = q > 1 ? M.times(n.once1, q) : null;
      html +=
        '<div class="alev2-tierwrap">' +
        (t.ribbon ? '<span class="alev2-ribbon">' + esc(t.ribbon) + "</span>" : "") +
        '<button type="button" class="alev2-tier' + (state.qty === q ? " is-active" : "") + '" data-alev2="qty" data-q="' + q + '" aria-pressed="' + (state.qty === q) + '">' +
        '<span class="alev2-thumb"><img src="' + img(S.images["thumb" + q] ? "thumb" + q : "thumb") + '" alt=""></span>' +
        '<span class="alev2-tier-mid"><span class="alev2-tier-name"><b>' + esc(M.units(q, S.unit.one, S.unit.many)) + "</b>" +
        (t.pill ? "<span>" + esc(t.pill) + "</span>" : "") + "</span>" +
        '<span class="alev2-tier-unit" style="display:block">' + esc(fill(C.oncePerUnit, { x: M.money(M.perUnit(t.price, q)) })) + "</span>" +
        '<span class="alev2-tier-note" style="display:block">' + esc(C.onceNote) + "</span></span>" +
        '<span class="alev2-tier-price"><b>' + M.money(t.price) + "</b>" + (strike !== null ? "<s>" + M.money(strike) + "</s>" : "") + "</span>" +
        "</button></div>";
    }
    return html;
  }

  function extrasHtml() {
    var html = '<p class="alev2-label is-extras">' + esc(state.sub ? C.extrasSub : C.extrasOnce) + "</p>";
    for (var i = 0; i < C.gifts.length; i++) {
      var g = C.gifts[i];
      var price = M.money(data.gifts[g.match]);
      var mid =
        '<span class="alev2-ico">' + ICON[g.icon] + "</span>" +
        '<span class="alev2-row-mid"><b>' + esc(g.title) + "</b><span>" + esc(state.sub ? g.textSub : g.textOnce) + "</span></span>";
      if (state.sub) {
        // Included with the subscription (the widget sends it as a $0 line).
        html +=
          '<div class="alev2-row is-active"><span class="alev2-box is-on">' + ICON.check + "</span>" + mid +
          '<span class="alev2-row-end"><b>' + esc(C.giftIncluded) + "</b><s>" + price + "</s></span></div>";
      } else {
        var on = !!state.gifts[g.match];
        html +=
          '<button type="button" class="alev2-row' + (on ? " is-active" : "") + '" data-alev2="gift" data-g="' + i + '" aria-pressed="' + on + '">' +
          '<span class="alev2-box ' + (on ? "is-on" : "is-off") + '">' + ICON.check + "</span>" + mid +
          '<span class="alev2-row-end is-price"><b>' + price + "</b></span></button>";
      }
    }
    for (var j = 0; j < UPS.length; j++) {
      var u = UPS[j];
      var d = data.upsells[u.match];
      var up = !!state.upsells[u.match];
      html +=
        '<button type="button" class="alev2-row' + (up ? " is-active" : "") + '" data-alev2="upsell" data-u="' + j + '" aria-pressed="' + up + '">' +
        '<span class="alev2-box ' + (up ? "is-on" : "is-off") + '">' + ICON.check + "</span>" +
        '<span class="alev2-ico' + (u.image ? " is-img" : "") + '">' + (u.image ? '<img src="' + img(u.image) + '" alt="">' : ICON[u.icon]) + "</span>" +
        '<span class="alev2-row-mid"><b>' + esc(u.title) + "</b><span>" + esc(state.sub ? u.textSub : u.textOnce) + "</span></span>" +
        '<span class="alev2-row-end is-price"><b>' + M.money(state.sub ? d.sub.price : d.once) + "</b>" +
        (state.sub && d.sub.strike !== null ? "<s>" + M.money(d.sub.strike) + "</s>" : "") +
        "</span></button>";
    }
    return html;
  }

  function giftLines() {
    var out = "";
    for (var j = 0; j < UPS.length; j++) {
      var u = UPS[j];
      if (!state.upsells[u.match]) continue;
      var d = data.upsells[u.match];
      out += '<div class="alev2-sum-line"><span>' + esc(u.title) + "</span><b>" + M.money(state.sub ? d.sub.price : d.once) + "</b></div>";
    }
    if (state.sub) return out;
    for (var i = 0; i < C.gifts.length; i++) {
      var g = C.gifts[i];
      if (state.gifts[g.match]) {
        out += '<div class="alev2-sum-line"><span>' + esc(g.title) + "</span><b>" + M.money(data.gifts[g.match]) + "</b></div>";
      }
    }
    return out;
  }

  function summaryHtml(n) {
    var line = state.sub
      ? C.sumSub
      : fill(C.sumOnce, { units: M.units(state.qty, S.unit.one, S.unit.many) });
    var price = state.sub ? n.p : data.once[state.qty].price;
    var ship = S.freeShipping && state.sub ? C.sumShipFree : C.sumShipCalc;
    var total = n.total === null ? "" : M.money(n.total);
    return (
      '<div class="alev2-sum' + (state.sub ? "" : " is-once") + '">' +
      '<div class="alev2-sum-line"><span>' + esc(line) + "</span><b>" + M.money(price) + "</b></div>" +
      giftLines() +
      '<div class="alev2-sum-line"><span>' + esc(C.sumShip) + '</span><b class="is-ship">' + esc(ship) + "</b></div>" +
      '<div class="alev2-sum-total"><span>' + esc(C.sumTotal) + "</span><strong>" + total + "</strong></div>" +
      (state.sub ? '<div class="alev2-sum-next"><span>' + esc(C.sumNext) + "</span><b>" + esc(fill(C.sumNextValue, { x: M.money(n.nextAll) })) + "</b></div>" : "") +
      '<p class="alev2-sum-note">' +
      esc(
        state.sub
          ? (n.extra ? C.noteSubExtra : "") + fill(C.noteSub, { next: M.money(n.nextAll) })
          : fill(C.noteOnce, { cuota: n.cuota === null ? "" : M.money(n.cuota) })
      ) +
      "</p>" +
      "</div>"
    );
  }

  function barHtml(n) {
    var label = state.sub ? fill(C.ctaSub, { pct: n.pct }) : C.ctaOnce;
    var note = state.sub
      ? fill(C.ctaNoteSub, { first: M.money(n.today), next: M.money(n.nextAll) }) + (S.freeShipping ? C.ctaNoteSubShip : "")
      : C.ctaNoteOnce;
    var pay = "";
    for (var i = 0; i < C.pay.length; i++) pay += (i ? "<span>·</span>" : "") + "<span>" + esc(C.pay[i]) + "</span>";
    return (
      '<div class="alev2-bar"><button type="button" class="alev2-cta' + (state.sub ? "" : " is-once") + '" data-alev2="cta">' +
      "<span>" + esc(label) + '</span><span class="alev2-cta-price">' + (n.total === null ? "" : M.money(n.total)) + "</span></button>" +
      '<div class="alev2-cta-note">' + esc(note) + "</div>" +
      '<div class="alev2-pay">' + pay + "</div></div>"
    );
  }

  // ---- "bloom" layout (S.layout) ----------------------------------------------
  // Two stacked choice cards with a radio (one-time on top, subscription below with
  // the benefits inside), then a quantity stepper next to one CTA. Same state, numbers
  // and widget driving as the default layout; only the markup differs.
  // Per stick, rounded to whole pesos: an estimate next to the price, never charged.
  function perServing(pesos, units) {
    return fill(B.perServing, { x: M.money(Math.round(pesos / (units * S.servingsPerUnit))) });
  }

  function bloomCardsHtml(n) {
    // One stepper for both cards (Bloom): each shows the pack of the chosen quantity.
    var oq = data.once[state.qty] ? state.qty : 1;
    var once = data.once[oq].price;
    var bens = kept(C.benefits);
    var bensHtml = "";
    for (var i = 0; i < bens.length; i++) bensHtml += "<li>" + ICON.tick + "<span>" + esc(fill(bens[i].text, { next: M.money(n.next) })) + "</span></li>";
    // What one-time gives up, with a cross (the widget's oneTimeCons look). An item
    // with tick:true is something one-time does offer (installments): it gets the tick.
    var cons = kept(B.onceCons || []);
    var consHtml = "";
    for (var c = 0; c < cons.length; c++) {
      consHtml += "<li>" + (cons[c].tick ? ICON.tick : '<i class="alev2-bl-x">✕</i>') + "<span>" + esc(fill(cons[c].text, { pct: n.pct })) + "</span></li>";
    }
    // Subscription on top, one-time below (user 06/10).
    return (
      '<div class="alev2-bl-card is-split is-sub' + (state.sub ? " is-active" : "") + '">' +
      '<span class="alev2-flag">' + esc(C.subFlag) + "</span>" +
      '<button type="button" class="alev2-bl-head" data-alev2="pick" data-sub="1" aria-pressed="' + state.sub + '">' +
      '<span class="alev2-bl-radio"></span>' +
      '<span class="alev2-bl-main"><b>' + esc(B.subTitle) + '<i class="alev2-bl-pill">' + esc(fill(B.subPill, { pct: n.pct })) + "</i></b>" +
      "<span>" + esc(fill(B.subSub, { units: M.units(n.qty, S.unit.one, S.unit.many) })) + "</span></span>" +
      '<span class="alev2-bl-end"><b>' + M.money(n.today) + "<s>" + M.money(n.todayWas) + "</s></b><span>" + esc(perServing(n.p, n.qty)) + "</span></span>" +
      "</button>" +
      '<ul class="alev2-bl-bens">' + bensHtml + "</ul>" +
      "</div>" +
      '<div class="alev2-bl-card is-split' + (state.sub ? "" : " is-active") + '">' +
      '<button type="button" class="alev2-bl-head" data-alev2="pick" data-sub="0" aria-pressed="' + !state.sub + '">' +
      '<span class="alev2-bl-radio"></span>' +
      '<span class="alev2-bl-main"><b>' + esc(B.onceTitle) + "</b><span>" + esc(B.onceSub) + "</span></span>" +
      // A multi-box pack is struck against N single boxes only when it costs less.
      '<span class="alev2-bl-end is-once"><b>' + M.money(once) + (once < M.times(n.once1, oq) ? "<s>" + M.money(M.times(n.once1, oq)) + "</s>" : "") + "</b><span>" + esc(perServing(once, oq)) + "</span></span>" +
      "</button>" +
      (consHtml ? '<ul class="alev2-bl-bens is-cons">' + consHtml + "</ul>" : "") +
      "</div>"
    );
  }

  // The quantities the selected mode really sells, ascending (tiers may skip numbers).
  function bloomQtys() {
    var qs = (state.sub ? data.subQtys : data.onceQtys).slice();
    qs.sort(function (a, b) {
      return a - b;
    });
    return qs;
  }

  function bloomBuyHtml(n) {
    // One stepper for both modes: N boxes once, or N boxes every delivery.
    var qs = bloomQtys();
    var at = qs.indexOf(state.qty);
    var stepper =
      '<div class="alev2-bl-qty">' +
      '<button type="button" data-alev2="step" data-d="-1" aria-label="' + esc(B.qtyLess) + '"' + (at <= 0 ? " disabled" : "") + ">−</button>" +
      "<span>" + state.qty + "</span>" +
      '<button type="button" data-alev2="step" data-d="1" aria-label="' + esc(B.qtyMore) + '"' + (at === -1 || at >= qs.length - 1 ? " disabled" : "") + ">+</button>" +
      "</div>";
    // No note under the subscription CTA: the card's ticks already say what is charged and
    // when (user 13/10). No text row of payment methods either: the theme shows their logos
    // right below (user 06/10). One-time keeps its installments note.
    var note = state.sub ? "" : fill(C.noteOnce, { cuota: n.cuota === null ? "" : M.money(n.cuota) });
    return (
      '<div class="alev2-bar alev2-bl-bar"><div class="alev2-bl-buy">' + stepper +
      '<button type="button" class="alev2-bl-cta" data-alev2="cta">' +
      esc(state.sub ? B.ctaSub : B.ctaOnce) + (n.total === null ? "" : " · " + M.money(n.total)) + "</button></div>" +
      (note ? '<div class="alev2-cta-note">' + esc(note) + "</div>" : "") + "</div>"
    );
  }

  function render() {
    if (phase !== "active") return;
    var n = numbers();
    if (BLOOM) {
      // The gift row stays in both modes: a paid opt-in in one-time, ticked and locked as
      // "Incluida" in subscription (user 07/10).
      el.innerHTML = bloomCardsHtml(n) + extrasHtml() + bloomBuyHtml(n);
      state.animate = false;
      return;
    }
    el.innerHTML =
      badgesHtml(n) +
      (state.sub ? subCardHtml(n) : onceHtml(n)) +
      extrasHtml() +
      summaryHtml(n) +
      barHtml(n);
    state.animate = false;
  }

  // ---- events ------------------------------------------------------------------

  function onClick(e) {
    var t = e.target.closest ? e.target.closest("[data-alev2]") : null;
    if (!t || !el.contains(t)) return;
    var act = t.getAttribute("data-alev2");
    // Picking the card that is already selected changes nothing.
    if (act === "pick" && (t.getAttribute("data-sub") === "1") === state.sub) return;
    if (act === "toggle" || act === "pick") {
      state.sub = !state.sub;
      // Bloom keeps the stepper's quantity when the other mode sells it too.
      var keep = act === "pick" && (state.sub ? data.subs[state.qty] : data.once[state.qty]);
      if (!keep) state.qty = 1;
      state.gifts = {};
      state.upsells = {};
      state.detail = false;
      state.animate = true;
    } else if (act === "qty") {
      state.qty = parseInt(t.getAttribute("data-q"), 10);
    } else if (act === "step") {
      var qs = bloomQtys();
      var nq = qs[qs.indexOf(state.qty) + parseInt(t.getAttribute("data-d"), 10)];
      if (nq === undefined) return;
      state.qty = nq;
    } else if (act === "gift") {
      var gm = C.gifts[parseInt(t.getAttribute("data-g"), 10)].match;
      state.gifts[gm] = !state.gifts[gm];
    } else if (act === "upsell") {
      var um = UPS[parseInt(t.getAttribute("data-u"), 10)].match;
      state.upsells[um] = !state.upsells[um];
    } else if (act === "detail") {
      state.detail = !state.detail;
      render();
      return;
    } else if (act === "cta") {
      t.disabled = true;
      sync(function (ok) {
        t.disabled = false;
        var b = cta();
        if (ok && b) b.click();
      });
      return;
    }
    render();
    sync(render);
  }

  // ---- boot ----------------------------------------------------------------------

  function activate() {
    phase = "active";
    var pal = S.palette;
    for (var k in pal) if (Object.prototype.hasOwnProperty.call(pal, k)) el.style.setProperty("--a-" + k, pal[k]);
    document.documentElement.classList.add("alev2-on");
    el.addEventListener("click", onClick);
    // The widget re-renders on every change (CTA total, gift): mirror it.
    new MutationObserver(function () {
      if (phase === "active") render();
    }).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["aria-checked"] });
    render();
    sync(render);
  }

  // Harvest both states once: read the current one, flip the widget's switch, read
  // the other, flip back to subscription. Meanwhile ale.css keeps the widget hidden
  // (alev2-hold); warn() releases it if this gives up.
  function boot() {
    el = document.getElementById("alev2");
    root = document.querySelector("[data-mp-subscribe]");
    if (!el || !root || !S || !M) return warn("missing container, widget or store data");
    var started = Date.now();
    var flips = 0;
    (function poll() {
      if (Date.now() - started > TIMEOUT_MS) {
        phase = "failed";
        return warn("timed out reading the widget");
      }
      var sub = isSubOn();
      if (sub === null || !readTiers() || !cta()) return setTimeout(poll, 120);
      harvestCurrent();
      // The shared progression block only shows the selected tier: select the
      // 1-unit tier to read its 2nd charge.
      if (sub && data.sub && data.sub.next === null && !data.sub.checked) {
        data.sub.el.click();
        return setTimeout(poll, 120);
      }
      // Bloom shows every subscription tier's 2nd charge: select each one once to read it.
      var unread = sub && BLOOM ? subMissingNext() : null;
      if (unread && !unread.checked) {
        unread.el.click();
        return setTimeout(poll, 120);
      }
      if (haveAll()) {
        if (sub) return activate();
        checkbox().click();
        return setTimeout(poll, 120);
      }
      if (flips < 3) {
        flips++;
        checkbox().click();
      }
      setTimeout(poll, 160);
    })();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
